/**
 * 회전값(Math.cos, Math.sin) 캐싱 유틸리티
 * 성능 최적화를 위해 동일한 회전각도의 삼각함수 값을 캐싱합니다.
 */

// 절댓값 회전값 캐시 (Math.abs 적용, 아웃글로우 등에서 사용)
const absRotationCache = new Map<number, { cos: number; sin: number }>();

/**
 * 회전각도에 대한 절댓값 cos, sin 값을 반환합니다 (캐싱됨)
 * 아웃글로우 바운딩박스 계산 등에서 사용
 * @param angle 회전각도 (라디안)
 * @returns { cos, sin } 객체 (절댓값)
 */
export const getAbsRotationValues = (angle: number): { cos: number; sin: number } => {
  if (!absRotationCache.has(angle)) {
    absRotationCache.set(angle, {
      cos: Math.abs(Math.cos(angle)),
      sin: Math.abs(Math.sin(angle))
    });
  }
  return absRotationCache.get(angle)!;
};

/**
 * 캐시를 초기화합니다 (테스트 또는 메모리 관리용)
 */
export const clearRotationCache = (): void => {
  absRotationCache.clear();
};

